import * as React from "react";

import { useFloatingControlClassName } from "@/components/ui/floating-field";
import {
  formControlHeightClassName,
  formControlNativeDisabledClassName,
  formControlSingleLineLayoutClassName,
} from "@/components/ui/form-control-styles";
import { cn } from "@/lib/utils";

function Input({ className, type, ...props }: React.ComponentProps<"input">) {
  const floatingClassName = useFloatingControlClassName();

  return (
    <input
      type={type}
      data-slot="input"
      className={cn(
        floatingClassName || cn(formControlHeightClassName, formControlSingleLineLayoutClassName),
        "w-full min-w-0 rounded-lg border border-input bg-transparent transition-colors outline-none file:inline-flex file:h-6 file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground aria-invalid:placeholder:text-destructive focus-visible:border-ring focus-visible:ring-3 focus-visible:ring-ring/50",
        formControlNativeDisabledClassName,
        "aria-invalid:border-destructive aria-invalid:ring-0 dark:bg-input/30 dark:aria-invalid:border-destructive/50 aria-invalid:focus-visible:border-destructive aria-invalid:focus-visible:ring-3 aria-invalid:focus-visible:ring-destructive/20 dark:aria-invalid:focus-visible:ring-destructive/40",
        className,
      )}
      {...props}
    />
  );
}

export { Input };
